"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function last(src) {
    return src[src.length - 1];
}
exports.last = last;
function zipObject(props, values) {
    var ret = {};
    for (var i = 0; i < props.length; i++) {
        ret[props[i]] = values[i];
    }
    return ret;
}
exports.zipObject = zipObject;
function dropRight(n, array) {
    var ret = array.slice();
    for (var i = 0; i < n; i++) {
        ret.pop();
    }
    return ret;
}
exports.dropRight = dropRight;
//# sourceMappingURL=lodash-alt.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/lodash-alt.js
// module id = 103
// module chunks = 0